import { createContext, useCallback, useContext, useState } from "react";
import { ValidatorProvider } from "react-admin-base";
import { LoadingButton, ValidationErrors } from "react-admin-base-bootstrap";
import { FormattedMessage } from "react-intl";
import { Form, Alert } from "reactstrap";
import { useUserRefresher } from "./UserProvider";

const SaveButtonContext = createContext();

export function useSaveButton() {
	return useContext(SaveButtonContext);
}

export default function FancyEntityEditor(props) {
	const { entity, disabled, children, onSave } = props;
	
	const [ _1, _2, save, loading ] = entity;
	
	  const [ saved, setSaved ] = useState(false);
	  const [ error, setError ] = useState(false);
	  const userRefresher = useUserRefresher();
	
	  const onSubmit = useCallback(async function(e) {
		e.preventDefault();
		e.stopPropagation();
	
		if (saved) {
		  setSaved(false);
		}
	
		if (error) {
		  setError(null);
		}
	
		try {
		  await save();
		  onSave && onSave();
		  setSaved(true);
		  await userRefresher();
		} catch(e) {
		  console.error(e);
		  setError((e.response && e.response.data && e.response.data.message) || (error.data && error.data.message) || e.data || e.message || e);
		}
		finally
		{
	
		}
	  }, [save, saved, error, userRefresher]);
	
	  const savedAlert = saved && <Alert color="success" toggle={() => setSaved(false)}><i className="fas fa-check-circle me-2" /><FormattedMessage id="ENTITY.SAVED" /></Alert>;
	  
	  const saveBtn = <LoadingButton block loading={loading} type="submit" color="primary"><i className="fas fa-save fa-lg" /> { <FormattedMessage id="ENTITY.SAVE" /> }</LoadingButton>;
	
	  return <SaveButtonContext.Provider value={saveBtn}>
	  	<ValidatorProvider>
			<Form onSubmit={onSubmit} disabled={!!loading || !!disabled}>
		  	{ loading && <Alert color="warning" toggle={() => setSaved(false)}>
				<i className="fa fa-spin fa-spinner" />{' '}
				<FormattedMessage id="PLEASE_WAIT"/>
		  	</Alert>}
		  	{ savedAlert }
		  	{ error && <Alert color="danger" toggle={() => setError(null)}>{ error }</Alert>}
		  	<fieldset disabled={!!loading || !!disabled}>
				{ children }
		  	</fieldset>
		  	<ValidationErrors />
		  	{ savedAlert }
			</Form>
		</ValidatorProvider>
  	</SaveButtonContext.Provider>;
}